var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Spectrum"}},[(!_vm._isMobile())?_c('SpectrumPC'):_vm._e(),(_vm._isMobile())?_c('SpectrumH5'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }